import React, { useState, useRef, useEffect } from 'react';
import { InputAdornment, Input, Icon } from 'tea-component';
import classNames from 'classnames';
import { ICustomRangeProps } from '../../_type';
import './index.scss';

// 组装接口配置和页面配置的相关信息传递给子组件 ，如：nameEn、nameCn、formatter、width、tooltipEn、tooltipCn等
const CustomRange = (props: ICustomRangeProps) => {
  const { className = '', style ={}, value = { min: '', max: '' }, onChange=()=>{}, unitText = '$',
    leftPlaceholder, rightPlaceholder, selectedRadio } = props || {};
  // eslint-disable-next-line no-useless-escape
  const { errorReg = /^[0-9]*[\.]?[0-9]*$/, errorMsg: propsErrorMsg = 'dbb_input_error'} = selectedRadio || {};
  // 起始值、结束值
  const inputMinRef = useRef<HTMLInputElement>(null);
  const inputMaxRef = useRef<HTMLInputElement>(null);
  // 最大最小值
  const [minValue, setMinValue] = useState('');
  const [maxValue, setMaxValue] = useState('');
  // 最小值错误提示，用于最小值输入框样式处理
  const [isMinError, setIsMinError] = useState(false);
  // 最大值错误提示，用于最大值输入框样式处理
  const [isMaxError, setIsMaxError] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  // BMK最大数值限制999.99B,这个bmk最大值的逻辑是复用之前pcu和revenue筛选器的逻辑
  const BMK = 999999999999;
  
  useEffect(() => {
    setMinValue(value?.min ? `${value?.min}` : value?.min === 0 ? '0' : '');
    setMaxValue(value?.max ? `${value?.max}` : value?.max === 0 ? '0' : '');
  }, [JSON.stringify(value)]);
  
  const handleInputChange = (val: string, type: 'min' | 'max', targetVal?: string) => {
    const value = val?.replace(/[,， ]/g, '');
    let newMinVal = minValue;
    let newMaxVal = maxValue;
    let newIsMinError = isMinError;
    let newIsMaxError = isMaxError;
    let newErrorMsg = errorMsg;
    if (type === 'min') {
      newMinVal = value;
      if (!value) {
        newIsMinError = false;
      } else if (!errorReg.test(value)) {
        newIsMinError = true;
        newErrorMsg = propsErrorMsg;
      } else if (Number(value) > BMK) {
        newMinVal = `${BMK}`;
      } else {
        const targetValue = Number(value) > BMK ? BMK : value;
        const maxVal = targetVal ? targetVal : maxValue;
        if (maxVal && Number(targetValue) > Number(maxVal)) {
          newIsMinError = true;
          newErrorMsg = 'dbb_input_more_max';
        } else {
          newIsMinError = false;
          if (isMaxError) {
            if(newMaxVal && Number(newMaxVal) > Number(newMinVal) && errorReg.test(newMaxVal)){
              newErrorMsg = isMinError ?  newErrorMsg : '';
              newIsMaxError = false;
            }

          }
        }
      }
    } else {
      newMaxVal = value;
      if (!value) {
        newIsMaxError = false;
      } else if (!errorReg.test(value)) {
        newIsMaxError = true;
        newErrorMsg = propsErrorMsg;
      } else if (Number(value) > BMK) {
        newMaxVal = `${BMK}`;
      } else {
        const minVal = targetVal ? targetVal : minValue;
        if (minVal && Number(value) < Number(minVal)) {
          newIsMaxError = true;
          newErrorMsg = 'dbb_input_less_min';
        } else {
          newIsMaxError = false;
          if (isMinError) {
            if(newMinVal && Number(newMaxVal) > Number(newMinVal) && errorReg.test(newMinVal)){
              newErrorMsg = isMaxError ?  newErrorMsg : '';
              newIsMinError = false;
            }
          }
        }
      }
    }

    setMinValue(newMinVal);
    setMaxValue(newMaxVal);
    setIsMinError(newIsMinError);
    setIsMaxError(newIsMaxError);
    setErrorMsg(newErrorMsg);
    onChange({
      min: newMinVal ? newMinVal : '',
      max: newMaxVal ? newMaxVal : '',
      errorMsg: (newIsMinError || newIsMaxError) ? newErrorMsg : '' ,
    });
  };
  // 删除输入框的值
  const handleDeleteRevenueRange = (type: 'min' | 'max') => {
    if (type === 'max') {
      setMaxValue('');
      setIsMaxError(false);
      onChange({
        min: minValue,
        max: '',
        errorMsg: isMinError ? errorMsg : '' ,
      });
      if (inputMaxRef?.current) {
        inputMaxRef?.current?.focus();
      }
  
    } else {
      setMinValue('');
      setIsMinError(false);
      onChange({
        min: '',
        max: maxValue,
        errorMsg: isMaxError ? errorMsg : '' ,
      });
      if (inputMinRef?.current) {
        inputMinRef?.current?.focus();
      }
    }
 
  };
  
  // // 点击输入框
  // const handleInputClick = (type: 'min' | 'max') => {
  //   if (!clickSetDefault) return;
  //   if (type === 'max' && !maxValue) {
  //     handleInputChange('250000', 'max');
  //   }
  //   if (type === 'min' && !minValue) {
  //     handleInputChange('20000', 'min');
  //   }
  // };
    

  return  <div className={classNames('dbb-custom-range-select', className)} style={style}>
    <div className="dbb-custom-range-select-input">
      <InputAdornment
        className="dbb-custom-range-box"
        before={unitText}
        style={{ display: 'flex' }}
      >
        <Input
          ref={inputMinRef}
          value={minValue}
          placeholder={leftPlaceholder}
          // onClick={() => handleInputClick('min')}
          onChange={(val) => {handleInputChange(val, 'min')}}
          style={{ paddingRight: minValue ? 30 : 0 }}
          className={classNames([{ 'is-error': isMinError }, 'dbb-custom-range-input'])}
        />
        {minValue ? (
          <Icon
            className="dbb-custom-range-icon"
            type="dismiss"
            onClick={() => handleDeleteRevenueRange('min')}
          />
        ) : null}
      </InputAdornment>
      <span className="dbb-custom-range-select-divide">-</span>
      <InputAdornment
        className="dbb-custom-range-box"
        before={unitText}
        style={{ display: 'flex' }}
      >
        <Input
          ref={inputMaxRef}
          value={maxValue}
          onChange={(val) => {handleInputChange(val, 'max')}}
          // onClick={() => handleInputClick('max')}
          placeholder={rightPlaceholder}
          style={{ paddingRight: maxValue ? 30 : 0 }}
          className={classNames([{ 'is-error': isMaxError }, 'dbb-custom-range-input'])}
        />
        {maxValue ? (
          <Icon
            className="dbb-custom-range-icon"
            type="dismiss"
            onClick={() => handleDeleteRevenueRange('max')}
          />
        ) : null}
      </InputAdornment>
    </div>
  </div>;
};

export default CustomRange;
